// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

ion-spinner {
  width: 30px;
  height: 30px;
  color: black !important;
}

.custom-table {
  border-collapse: collapse;
  table-layout: fixed; /* Helps maintain column widths even with dynamic content */
}

.custom-table th,
.custom-table td {
  text-align: left;
  padding: 8px; /* Adjust padding to suit your design needs */
}

.custom-table th {
  font-weight: normal; /* Removes bold from headers */
  background-color: #f5f5f5; /* Light gray background for headers */
  color: #41505a !important;
  font-weight: 500;
}

.custom-table td em {
  /* Emphasis for content */
  font-style: normal;
  color: rgba(9, 85, 237, 0.878);
}

.fat-border-bot th {
  border-bottom: 2px solid #ccc; /* Stylish thick border for header */
}

.swu-row:nth-child(even) {
  background-color: #f9f9f9; /* Zebra striping for rows */
}

.spin {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.software-select-dropdown {
  color: #41505a !important;
  background: #fff;
  height: 38px;
  border: solid;
  border-width: thin;
  border-color: #41505a;
}

.firmware-ready-row {
  color: #41505a !important;
  margin: 0;
  padding-top: 2rem;
}

.firmware-preparing {
  color: #41505a !important;
  margin: 0;
  padding-top: 2rem;
}

.link-button {
  padding: 0;
  cursor: pointer;
  margin-right: 17rem;
  margin-left: 0;
  width: 12rem;
}

.link-button--trailing {
  margin-left: auto;
}

.sparepar-button {
  width: 12rem;
}

.underline-div {
  height: 1px;
  align-self: end;
  margin: 0;
  border-bottom: 1px solid #d1d1d1;
  width: 100%;
  padding-top: 2.5rem;
}

.upgrade-item {
  --padding-start: 10px;
  --inner-padding-end: 10px;
  --background: transparent;
  --inner-border-width: 0;
  --border-width: 0;
  --highlight-height: 0;
  --show-full-highlight: 0;
}

ion-item.upgrade-item::part(native) {
  border: none !important;
  box-shadow: none !important;
}

.upgrade-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.upgrade-pct {
  font-size: 14px;
  opacity: 0.75;
  white-space: nowrap;
  font-weight: 600;
}

.upgrade-title {
  font-size: 14px;
  font-weight: 600;
}

.progress-shell {
  padding: 6px 12px; /* prevents edge-to-edge */
  border-radius: 999px;
  background: var(--ion-color-step-100, rgba(0, 0, 0, 0.06));
  border: 1px solid var(--ion-color-step-200, rgba(0, 0, 0, 0.1));
}

.progress-shell ion-progress-bar {
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
}

.upgrade-hint {
  margin-top: 10px;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 500;
  opacity: 0.75;
  display: flex;
  align-items: center;
  gap: 8px;
}

.hint-icon {
  font-size: 18px;
  margin: 0;
  color: red;
  flex: 0 0 auto;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/spare-part-modal-service/spare-part-modal-service.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AAAF;;AAGA;EACE,yBAAA;EAEA,mBAAA,EAAA,2DAAA;AADF;;AAIA;;EAEE,gBAAA;EACA,YAAA,EAAA,6CAAA;AADF;;AAIA;EACE,mBAAA,EAAA,8BAAA;EACA,yBAAA,EAAA,sCAAA;EACA,yBAAA;EACA,gBAAA;AADF;;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,8BAAA;AADF;;AAIA;EACE,6BAAA,EAAA,oCAAA;AADF;;AAIA;EACE,yBAAA,EAAA,4BAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AADF;;AAGA;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;AAAF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;EAEA,eAAA;EAEA,mBAAA;EACA,cAAA;EACA,YAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,mBAAA;AADF;;AAIA;EACE,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wBAAA;AADF;;AAIA;EACE,uBAAA;EACA,2BAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EAEA,gBAAA;AAFF;;AAKA;EACE,iBAAA,EAAA,0BAAA;EACA,oBAAA;EACA,0DAAA;EACA,+DAAA;AAFF;;AAKA;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,eAAA;EACA,SAAA;EAEA,UAAA;EACA,cAAA;EACA,cAAA;AAHF","sourcesContent":[".spinner-container {\r\n  position: relative;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\nion-spinner {\r\n  width: 30px;\r\n  height: 30px;\r\n  color: black !important;\r\n}\r\n\r\n.custom-table {\r\n  border-collapse: collapse;\r\n  //width: 100%;\r\n  table-layout: fixed; /* Helps maintain column widths even with dynamic content */\r\n}\r\n\r\n.custom-table th,\r\n.custom-table td {\r\n  text-align: left;\r\n  padding: 8px; /* Adjust padding to suit your design needs */\r\n}\r\n\r\n.custom-table th {\r\n  font-weight: normal; /* Removes bold from headers */\r\n  background-color: #f5f5f5; /* Light gray background for headers */\r\n  color: #41505a !important;\r\n  font-weight: 500;\r\n}\r\n\r\n.custom-table td em {\r\n  /* Emphasis for content */\r\n  font-style: normal;\r\n  color: rgba(9, 85, 237, 0.878);\r\n}\r\n\r\n.fat-border-bot th {\r\n  border-bottom: 2px solid #ccc; /* Stylish thick border for header */\r\n}\r\n\r\n.swu-row:nth-child(even) {\r\n  background-color: #f9f9f9; /* Zebra striping for rows */\r\n}\r\n\r\n.spin {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 20px;\r\n}\r\n.software-select-dropdown {\r\n  color: #41505a !important;\r\n  background: #fff;\r\n  height: 38px;\r\n  border: solid;\r\n  border-width: thin;\r\n  border-color: #41505a;\r\n}\r\n.firmware-ready-row {\r\n  color: #41505a !important;\r\n  margin: 0;\r\n  padding-top: 2rem;\r\n}\r\n\r\n.firmware-preparing {\r\n  color: #41505a !important;\r\n  margin: 0;\r\n  padding-top: 2rem;\r\n}\r\n\r\n.link-button {\r\n  padding: 0;\r\n\r\n  cursor: pointer;\r\n\r\n  margin-right: 17rem;\r\n  margin-left: 0;\r\n  width: 12rem;\r\n}\r\n\r\n.link-button--trailing {\r\n  margin-left: auto; // pushes it to the far right\r\n}\r\n\r\n.sparepar-button {\r\n  width: 12rem;\r\n}\r\n\r\n.underline-div {\r\n  height: 1px;\r\n  align-self: end;\r\n  margin: 0;\r\n  border-bottom: 1px solid #d1d1d1;\r\n  width: 100%;\r\n  padding-top: 2.5rem;\r\n}\r\n\r\n.upgrade-item {\r\n  --padding-start: 10px;\r\n  --inner-padding-end: 10px;\r\n  --background: transparent;\r\n  --inner-border-width: 0;\r\n  --border-width: 0;\r\n  --highlight-height: 0;\r\n  --show-full-highlight: 0;\r\n}\r\n\r\nion-item.upgrade-item::part(native) {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.upgrade-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.upgrade-pct {\r\n  font-size: 14px;\r\n  opacity: 0.75;\r\n  white-space: nowrap;\r\n  font-weight: 600;\r\n}\r\n\r\n.upgrade-title {\r\n  font-size: 14px;\r\n\r\n  font-weight: 600;\r\n}\r\n\r\n.progress-shell {\r\n  padding: 6px 12px; /* prevents edge-to-edge */\r\n  border-radius: 999px;\r\n  background: var(--ion-color-step-100, rgba(0, 0, 0, 0.06));\r\n  border: 1px solid var(--ion-color-step-200, rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n.progress-shell ion-progress-bar {\r\n  height: 8px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n}\r\n\r\n.upgrade-hint {\r\n  margin-top: 10px;\r\n  font-size: 13px;\r\n  line-height: 1.35;\r\n  font-weight: 500;\r\n  opacity: 0.75;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.hint-icon {\r\n  font-size: 18px;\r\n  margin: 0;\r\n  // padding-right: 5px;\r\n  color: red;\r\n  flex: 0 0 auto;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
